module.exports = __webpack_public_path__ + "images/5fbf73388fcdc2db0b2a34a73a93eb9a.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/hero.png
// module id = 843
// module chunks = 0